// Curve chart shortcuts for the Shortcuts dialog: the crosshair keys of a focused chart and the chart search of the Curves gallery.
import type { ShortcutDef } from "@/app/shortcuts";

export const CURVE_SHORTCUTS: readonly ShortcutDef[] = [
  {
    id: "curve-next-point",
    keys: [["←"], ["→"]],
    description: "Move the crosshair to the previous or next point",
  },
  {
    id: "curve-fine-step",
    keys: [
      ["Shift", "←"],
      ["Shift", "→"],
    ],
    description: "Move the crosshair in fine steps",
  },
  {
    id: "curve-ends",
    keys: [["Home"], ["End"]],
    description: "Move the crosshair to the first or last point",
  },
  { id: "curve-search", keys: [["/"]], description: "Search the charts" },
];
